import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import { IndustryBuilderGuard } from "@/components/auth/IndustryBuilderGuard";
import LandscapingProposalBuilder from "@/pages/LandscapingProposalBuilder";
export const Route = createFileRoute("/landscaping-builder")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><IndustryBuilderGuard industry="landscaping"><LandscapingProposalBuilder /></IndustryBuilderGuard></ProtectedRoute>) });
